import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import KakobuySpreadsheetArticle from "@/pages/article/kakobuy-spreadsheet-polska/page";
import CzyKakobuyBezpiecznyArticle from "@/pages/article/czy-kakobuy-jest-bezpieczny/page";
import KakobuyShippingPolskaArticle from "@/pages/article/kakobuy-shipping-polska/page";
import KakobuyFindsPolskaArticle from "@/pages/article/kakobuy-finds-polska/page";
import KakobuyOpinieArticle from "@/pages/article/kakobuy-opinie/page";
import KakobuyHaulPolskaArticle from "@/pages/article/kakobuy-haul-polska/page";
import KakobuyListaProduktowArticle from "@/pages/article/kakobuy-lista-produktow/page";
import KakobuyShoesSpreadsheetArticle from "@/pages/article/kakobuy-shoes-spreadsheet/page";
import KakobuyHoodieSpreadsheetArticle from "@/pages/article/kakobuy-hoodie-spreadsheet/page";
import KakobuyJakKorzystacArticle from "@/pages/article/kakobuy-jak-korzystac/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-polska",
    element: <KakobuySpreadsheetArticle />,
  },
  {
    path: "/artykul/czy-kakobuy-jest-bezpieczny",
    element: <CzyKakobuyBezpiecznyArticle />,
  },
  {
    path: "/artykul/kakobuy-shipping-polska",
    element: <KakobuyShippingPolskaArticle />,
  },
  {
    path: "/artykul/kakobuy-finds-polska",
    element: <KakobuyFindsPolskaArticle />,
  },
  {
    path: "/artykul/kakobuy-opinie",
    element: <KakobuyOpinieArticle />,
  },
  {
    path: "/artykul/kakobuy-haul-polska",
    element: <KakobuyHaulPolskaArticle />,
  },
  {
    path: "/artykul/kakobuy-lista-produktow",
    element: <KakobuyListaProduktowArticle />,
  },
  {
    path: "/artykul/kakobuy-shoes-spreadsheet",
    element: <KakobuyShoesSpreadsheetArticle />,
  },
  {
    path: "/artykul/kakobuy-hoodie-spreadsheet",
    element: <KakobuyHoodieSpreadsheetArticle />,
  },
  {
    path: "/artykul/kakobuy-jak-korzystac",
    element: <KakobuyJakKorzystacArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;